import { render } from "./CartDetail.vue?vue&type=template&id=265e9ba5"
import script from "./CartDetail.vue?vue&type=script&lang=js"
export * from "./CartDetail.vue?vue&type=script&lang=js"
script.render = render

export default script